import React, { useContext, useEffect, useState } from 'react'
import classNames from 'classnames'

import { Icon } from '@scentregroup/ui'

import { Item } from '../types'
import { LinkContext } from '../context'

import style from './index.scss'

const Pane: React.FC<{
  title?: string
  items: Array<Item>
  path?: Array<number>
  onClose?: () => void
  onExit?: () => void
}> = ({ title, items, path, onClose, onExit }) => {
  const Link = useContext(LinkContext)

  const [selection, setSelection] = useState<Array<number> | undefined>(path)

  useEffect(() => setSelection(path), [path])

  return (
    <>
      <div className={classNames(style.pane)}>
        {title && <div className={classNames(style.title)}>{title}</div>}
        {items.map((item, i) => {
          if (!item) {
            return null
          }

          if ('url' in item) {
            return (
              <Link
                key={i}
                to={item.url}
                className={classNames(item.className, style.link, style.item)}
                target={item.target}
              >
                {item.label}
              </Link>
            )
          }

          if ('items' in item) {
            const children = (
              <>
                {item.title}
                <Icon
                  size="small"
                  type="chevron-right"
                  className={classNames(style.chevron, style.icon)}
                />
              </>
            )

            return i === selection?.[0] ? (
              <div
                key={i}
                className={classNames(item.className, style.item, style.active)}
              >
                {children}
              </div>
            ) : (
              <button
                key={i}
                className={classNames(item.className, style.item, style.link)}
                onClick={() => setSelection([i])}
              >
                {children}
              </button>
            )
          }

          const x = { render: item }

          return <x.render key={i} />
        })}
        {onClose && (
          <button
            className={classNames(style.link, style.arrow)}
            onClick={onClose}
          >
            <Icon
              size="medium"
              type="arrow-left"
              className={classNames(style['action-icon'])}
            />
          </button>
        )}
        {onExit && (
          <button
            className={classNames(style.link, style.cross)}
            onClick={onExit}
          >
            <Icon
              size="small"
              type="cross"
              className={classNames(style['action-icon'])}
            />
          </button>
        )}
      </div>
      {(() => {
        if (selection?.length) {
          const selectedItem = items[selection[0]]
          if (selectedItem && 'items' in selectedItem) {
            return (
              <Pane
                key={selection[0]}
                title={selectedItem.hideTitle ? undefined : selectedItem.title}
                items={selectedItem.items}
                path={selection?.slice(1)}
                onClose={() => setSelection([])}
                onExit={onExit}
              />
            )
          }
        }

        return null
      })()}
    </>
  )
}

export default Pane
